import React, { Fragment, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/core'
import UnityReactApp from '../UnityReactApp/UnityReactApp'

const useStyles = makeStyles((theme) => ({}))

const UnityAppContainer = (props) => {
    const classes = useStyles()

    const unityStagePreviewControllerRef = useRef(null)

    const handleResetUnityState = async () => {
        if (unityStagePreviewControllerRef.current) {
            console.log('handleResetUnityState called')
            await unityStagePreviewControllerRef.current.unloadUnity()
        }
    }

    useEffect(() => {
        document.addEventListener('closeLessonPreview', () => handleResetUnityState())
        document.addEventListener('initLessonPreviewWithInfo', (e) => RunInitUnityLessonFromParams(e))
        document.addEventListener('unityLessonPreviewOnHide', () => unfocusCurrentUnityStagePreviewController())
        document.addEventListener('unityLessonPreviewOnShow', () => focusunfocusCurrentUnityStagePreviewController())

        return () => {
            document.removeEventListener('closeLessonPreview', () => handleResetUnityState())
            document.removeEventListener('initLessonPreviewWithInfo', (e) => RunInitUnityLessonFromParams(e))
            document.removeEventListener('unityLessonPreviewOnHide', () => unfocusCurrentUnityStagePreviewController())
            document.removeEventListener('unityLessonPreviewOnShow', () =>
                focusunfocusCurrentUnityStagePreviewController()
            )
        }
    }, [])

    const RunInitUnityLessonFromParams = (e) => {
        if (unityStagePreviewControllerRef != null && unityStagePreviewControllerRef.current) {
            unityStagePreviewControllerRef.current.InitUnityLessonFromParams(
                e.detail.customLessonId,
                e.detail.l1Id,
                e.detail.nodeId,
                e.detail.clickableSkipButton,
                e.detail.l2Id
            )
        } else {
            console.log('failed to InitUnityLessonFromParams since unityStagePreviewControllerRef is null')
        }
    }

    const unfocusCurrentUnityStagePreviewController = () => {
        if (unityStagePreviewControllerRef != null && unityStagePreviewControllerRef.current) {
            unityStagePreviewControllerRef.current.OnUnfocus()
        } else {
            console.log('failed to run onUnfocus')
        }
    }

    const focusunfocusCurrentUnityStagePreviewController = () => {
        if (unityStagePreviewControllerRef != null && unityStagePreviewControllerRef.current) {
            unityStagePreviewControllerRef.current.OnFocus()
        } else {
            console.log('failed to run onFocus')
        }
    }

    return (
        <div tabIndex={1} style={{ outline: 'none' }}>
            <UnityReactApp
                customLessonId={''}
                ref={unityStagePreviewControllerRef}
                nodeId={''}
                clickableSkipButton={true}
                dispatch={props.dispatch}
                basePath={props.basePath}
                buildName={props.buildName}
                previewHeight={props.previewHeight ? props.previewHeight : null}
                previewWidth={props.previewWidth ? props.previewWidth : null}
                useBorder={props.useBorder}
                webType={props.webType}
                dashboardLanguage={props.dashboardLanguage ? props.dashboardLanguage : null}
                urlReloadCheck={props.urlReloadCheck ? props.urlReloadCheck : null}
                settingsFilter={props.settingsFilter ? props.settingsFilter : null}
                shouldShowBetaTag={props.shouldShowBetaTag}
                urlLocation={props.urlLocation ? props.urlLocation : null}
                version={props.version}
            />
        </div>
    )
}

UnityAppContainer.propTypes = {}

const mapStateToProps = (state) => {
    return {
        organization: state.organization,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(UnityAppContainer)
